export function getGamePlayStatsForSelectionsScreen() {

    const storedTime = JSON.parse(localStorage.getItem('gamePlayTime') || '{"active": 0, "idle": 0}');
    const activeTime = Math.floor(storedTime.active / 1000) ;
    const idleTime = Math.floor(storedTime.idle / 1000) ;

    const totalPlayTime = localStorage.getItem('totalPlayTime');

    return {
        level: 0,
        turnPhase: 'selection-screens',
        turnNumber: 0,
        activeTime,
        idleTime,
        totalPlayTime,
    };
};
